export const GA_MEASUREMENT_ID = "G-PDJ78DX20J";

const gtag = (...args) => {
  if (typeof window.gtag === "function") {
    window.gtag(...args);
  }
};

export const trackPageView = (path) => {
  gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};

export const trackEvent = (name, params = {}) => {
  gtag("event", name, params);
};
